/* eslint-disable @ok/oklint/no-hardcode-variable */
/* eslint-disable @ok/oklint/no-space */
export default {
  index_assets_total: '資産総額',
  index_assets_top_crypto: '人気銘柄',
  index_assets_top_fluctuation: 'ランキング',
  index_medias_title: 'メディア',
  tutor_page_title: 'Android',
  tutor_page_step1:
    'OKJのアプリを開き、取引ページ右上のボタンをクリックまたは、取引所ページを選択し右下にあるアイコンをクリックしてください。',
  tutor_page_step2:
    'モニタリングウィンドウをオンにし、「アプリの上部に表示することを許可する」を有効にし、「コインを追加」をクリックしてください。新しいページでコインを選択し「保存」をクリックしてください。',
  see_more: 'もっと見る',
  rss_page_title: 'マーケットニュース',
  btc_index_top_subtitle:
    'OKJ BTC Indexとは、当社取引所にて1BTCを購入・売却するための価格情報を日々公表するものです。',
  btc_index_tip1:
    '掲載されている価格情報は、オーケーコイン・ジャパン株式会社または他の取引参加者がこの価格でお客様とお取引することを確約するものではありません。お取引に際しては、必ず当社取引情報をご確認ください。',
  btc_index_tip2:
    '当社運用上の制約などから、掲載情報には若干の時間差が生じる場合があります。また、本価格はシステムにより自動算定していますが、その時点のメンテナンス等によって、実際と異なる情報が掲載されている場合があります。',
  btc_index_tip3:
    '掲載されている価格情報は作成日時のものであり、あくまでも目安としてご利用ください。',
  btc_index_download_csv_file: 'CSV ダウンロード',
  btc_index_download_csv_title: '過去データ',
  btc_index_crypto_currency_name: '暗号資産',
  btc_index_crypto_currency_purchase: '購入',
  btc_index_crypto_currency_sell: '売却',
  btc_index_crypto_currency_market_price: '仲値',
  btc_index_crypto_currency_btc: 'ビットコイン',
  btc_index_crypto_currency_date: '作成日時',
  btc_index_crypto_currency_unit: '円',
  btc_index_crypto_currency_today: '本日',
  btc_index_crypto_currency_yesterday: '前日',
  btc_index_year_split_symbol: '年',
  btc_index_month_split_symbol: '月',
  btc_index_day_split_symbol: '日',
  today_change_date: '24時間',
  seven_days_date: '7日間',
  thirty_days_date: '30日間',
  this_year_date: '1年',
  view_all: 'もっと見る',
  currency_folder_close: '閉じる',
  currency_info_data_title:
    '{symbolFullName}（{currencyName}）のリアルタイム情報',
  currency_office_site: '公式サイト',
  currency_white_paper: 'ホワイトペーパー',
  currency_office_github: 'Github',
  currency_block_explorer: 'エクスプローラー',
  currency_block_twitter: 'Twitter',
  currency_block_facebook: 'facebook',
  currency_price_performance: '価格情報',
  currency_time_range: '対象期間',
  currency_price_amount: '変動額',
  currency_price_rate: '変動率',
  currency_market_info: '{currencyFullName}（{currencyName}）の基本情報',
  currency_market_value: '時価総額',
  currency_history_highest_price: '史上最高値',
  currency_history_lowest_price: '史上最安値',
  currency_first_release: '発行開始',
  currency_history_max_offer: '最大供給量',
  currency_circulation_amount: '循環供給量（流通量）',
  currency_circulation_rate: '流通率(％)',
  currency_belong_link: 'ネットワーク',
  currency_admit_ways: '承認方式',
  currency_base_info_title: '{symbolFullName}（{symbol}）とは',
  currency_buy_calculator_button: '購入',
  currency_buy_calculator_pay: '金額',
  currency_buy_calculator_get: '数量',
  currency_buy_calculator_title: '{symbol}購入シミュレーション',
  currency_trade_title: '取引所',
  currency_staking_title: 'ステーキング',
  currency_sns_title: '公式SNSアカウント',
  currency_media_title: 'メディア',
  currency_go_trade: '取引する',
  currency_go_apply: '申請する',
  currency_staking_content1: '預けて増やす報酬',
  currency_staking_content2: '毎日受け取る',
  currency_to_concern: 'フォロー',
  resource_title_about: '{currencyFullName}（{symbol}）関連サイト',
  faq_content_title: '{currencyFullName}（{symbol}）FAQ',
  currency_base_info_increase_tips1:
    '現在の{symbol}価格は{price}円。{symbol}価格は過去24時間で{percentage}％上昇。OKJは{symbol}価格をリアルタイムで更新します。',
  currency_base_info_decrease_tips1:
    '現在の{symbol}価格は{price}円。{symbol}価格は過去24時間で{percentage}％下落しています。OKJは{symbol}価格をリアルタイムで更新します。',
  currency_base_info_tips2:
    '{symbol}は暗号資産の時価総額ランキングで{rankNumber}位です。現在の{symbol}時価総額は{volumeCap}円です。',
  currency_base_info_tips3:
    '{symbol}の流通量は{circulationAmount}{symbol}で、最大供給量は{distributionAmount}{symbol}です。',
  currency_circulation_rate_tip: '流通量÷最大供給量',
  currency_circulation_amount_tip: '現在市場に流通している数量',
  currency_history_max_offer_tip: '市場に流通できる最大数量',
  currency_breadcrumbs_spot_title: 'マーケット',
  currency_breadcrumbs_sale_title: '販売所',
  currency_breadcrumbs_trade_title: '取引所',
  currency_breadcrumbs_title: '{currencyFullName}（{symbol}）',
  currency_year_split_symbol: '年',
  currency_month_split_symbol: '月',
  currency_day_split_symbol: '日',
  currency_price: '価格',
  web_homepage_recurringbuy_title: '積立',
  web_homepage_staking_title: 'ステーキング',
  web_homepage_staking_desc:
    '対象の暗号資産を保有しているだけで、毎日、収益（ステーキング報酬）を得ることができます。',
  web_homepage_staking_rate: '最大年率',
  web_homepage_staking_soon: 'Coming soon',
  view_home_register_right_tip1: '入出金は24時間365日即時対応',
  view_home_register_right_tip2: 'スプレッドはグローバル水準',
  view_home_register_right_tip3: '高い流動性と高速取引',
  view_home_reason_title: 'OKJが選ばれる5つの理由',
  view_home_reason_security_tip1: '万全なセキュリティと',
  view_home_reason_security_tip2: 'サポート体制',
  view_home_reason_security_tip3: '100%コールドウォレット管理',
  view_home_reason_security_tip4: '2段階認証などの資産保護',
  view_home_reason_security_tip5: '丁寧かつ迅速なサポート',
  view_home_reason_security_title1: 'セキュリティ',
  view_home_reason_security_title2: '設定',
  view_home_reason_balance_tip1: 'スピーディーな',
  view_home_reason_balance_tip2: '入出金・入出庫',
  view_home_reason_balance_tip3: '豊富なマルチチェーン対応',
  view_home_reason_balance_tip4: '24時間365日即時対応',
  view_home_reason_balance_tip5: '日本円・暗号資産の入出金',
  view_home_reason_balance_title1: '資産管理',
  view_home_reason_balance_title2: '画面',
  view_home_reason_trade_tip1: '狭いスプレッドと',
  view_home_reason_trade_tip2: '高い流動性',
  view_home_reason_trade_tip3: 'グローバル水準の取引環境',
  view_home_reason_trade_tip4: 'アルトコインの板取引対応',
  view_home_reason_trade_tip5: '利便性の高い取引ツール',
  view_home_reason_trade_title1: '取引所',
  view_home_reason_trade_title2: '',
  view_home_reason_api_tip1: '高性能かつ多機能な',
  view_home_reason_api_tip2: 'API環境',
  view_home_reason_api_tip3: 'websocket・REST API対応',
  view_home_reason_api_tip4: '高いリクエスト上限',
  view_home_reason_api_tip5: 'SDK提供',
  view_home_reason_api_title1: 'API仕様書',
  view_home_reason_api_title2: '',
  view_home_reason_inquiryForm_tip1: '充実した法人向け',
  view_home_reason_inquiryForm_tip2: 'サービス',
  view_home_reason_inquiryForm_tip3: '期末時価評価課税適用除外の申請対応',
  view_home_reason_inquiryForm_tip4: '大口取引・専属アカウントマネージャー対応',
  view_home_reason_inquiryForm_tip5: '海外法人の受入に対応',
  view_home_reason_inquiryForm_title1: 'お問い合わせ',
  view_home_reason_inquiryForm_title2: '',
  view_home_flow_title_tips2: '最短15分で取引スタート',
  view_home_flow_step1_title: 'メールアドレス登録',
  view_home_flow_step2_title1: 'スマホで本人確認',
  view_home_flow_step2_title2: '',
  view_home_flow_step3_title: '取引開始',
  view_home_sale_card_title: '簡単、手軽に取引を始めよう',
  view_home_sale_card_btn: '取引を始める',
  view_index_news_title: 'お知らせ',
  view_index_market_news_title: 'マーケットニュース',
  view_index_news_btn: 'もっと見る',
  view_home_faq_title: 'よくある質問',
  view_home_faq_guidelines_page: 'ガイドページ',
  view_home_faq_click_here: 'こちら',
  view_home_faq_more_link: 'https://support.okcoin.jp/hc/ja',
  view_home_faq_first_title: '口座開設申請にはどれくらいの時間がかかりますか',
  view_home_faq_first_info1:
    '最短5分で本人確認を含む口座開設申請の手続きが完了します。',
  view_home_faq_first_info2: '口座開設申請に必要な手続きは',
  view_home_faq_first_info3: 'をご覧ください。',
  view_home_faq_first_info4:
    '※口座開設申請には所定の審査があります。状況により審査完了までお時間を頂戴します。',
  view_home_faq_second_title: '法人でも口座開設することはできますか',
  view_home_faq_second_info1:
    '法人のお客様も、口座開設してサービスをご利用頂くことが可能です。',
  view_home_faq_second_info2: '口座開設に必要な手続きは',
  view_home_faq_second_info3: 'をご覧ください。',
  view_home_faq_third_title: '入出金／入出庫にはどれくらいの時間がかかりますか',
  view_home_faq_third_info1:
    'OKJでは24時間365日、日本円の入出金と暗号資産の入出庫に即時対応しています。',
  view_home_faq_third_info2:
    'お取引の機会を逃すことなくサービスをご利用いただけます。',
  view_home_faq_fourth_title: '取扱銘柄についておしえてください',
  view_home_faq_fourth_info1:
    '代表的な暗号資産であるBTC、ETH、XRPのほか、多くの暗号資産を取引所と販売所で取り扱っています。',
  view_home_faq_fourth_info2: '取引所の取扱い銘柄は',
  view_home_faq_fourth_info3: 'を、販売所の取扱い銘柄は',
  view_home_faq_fourth_info4: 'をご覧ください。',
  view_home_faq_fifth_title: '取引所と販売所の違いをおしえてください',
  view_home_faq_fifth_info1:
    '取引所は、買い手と売り手の注文のマッチングを行います。参加者の注文により注文板が形成されるため、板取引とも呼ばれます。注文方法を選択でき、取引コストを抑えた取引ができます。',
  view_home_faq_fifth_info2:
    '販売所は、お客様と暗号資産交換業者が取引を行う店頭取引で、注文後直ちに約定します。簡単な操作で売買ができ、初心者の方にもお使い頂きやすいサービスです。',
  view_home_faq_sixth_title: 'ステーキングサービスについておしえてください',
  view_home_faq_sixth_info1:
    'ステーキングは、暗号資産を保有して、ブロックチェーンの維持や承認に貢献できる仕組みです。貢献した対価として、ステーキング報酬を得ることができます。',
  view_home_faq_sixth_info2:
    'OKJのステーキングサービスでは毎日報酬を受け取ることができ、いつでもお申し込み・解除可能です。',
  view_home_faq_sixth_info3: '詳しいルールや条件は',
  view_home_faq_sixth_info4: 'をご確認ください。',
  view_home_faq_seventh_title:
    'Flash Deals（フラッシュディール）についておしえてください',
  view_home_faq_seventh_info1:
    'Flash Deals（フラッシュディール）に参加することで、期間限定で高い報酬を得ることができるサービスです。フラッシュディールごとに、対象の暗号資産、報酬（年率）、実施期間、受付数量が定められており、不定期で実施されます。',
  view_home_faq_seventh_info2: '詳しいルールや条件は',
  view_home_faq_seventh_info3: 'をご確認ください。',
  web_banner_register_button: 'いますぐ口座開設',
  web_homepage_download: 'アプリをダウンロード',
  web_homepage_product_buysell_dec:
    '販売所は、初心者にも分かりやすいUXで、簡単に暗号資産を売買できるサービスです。',
  web_homepage_product_trade_dec:
    '取引所は、お客様が希望する価格で、暗号資産を取引できるサービスです。あらゆる執行方法と高度なAPI接続が可能です。',
  web_homepage_bottom_download_title: 'いますぐアプリをダウンロード',
  web_homepage_recurringbuy_desc:
    '決まった金額の暗号資産を自動で定期的に購入できるサービスです。',
  web_homepage_download_subtitle: 'いつでも どこでも 取引しやすい',
  web_homepage_download_register: 'いますぐ登録',
  web_homepage_sale_title: '販売所',
  web_homepage_trade_title: '取引所',
  web_homepage_trade_volume: '24H 出来高',
  web_homepage_trade_date: '日時',
  // ekyc refactor
  'kyc.mini.title': 'かんたん本人確認',
  'kyc.mini.app.no.title': 'スマホにOKJアプリがありません',
  'kyc.mini.app.no.desc': 'アプリストアからアプリをダウンロードしてください',
  'kyc.mini.app.have.title': 'スマホにOKJアプリがあります',
  'kyc.mini.app.have.desc': '既にダウンロード済みの方(1.4.1以降が必要です)',
  'kyc.mini.toekyc.button': 'eKYCへ',
  'kyc.mini.tips.title': '注意事項',
  'kyc.mini.tips.desc.1': '＊必ず現在お住いの住所と一致する有効期限内の書類をご提出ください。',
  'kyc.mini.tips.desc.2': '＊「通知カード」は、マイナンバーカードとしてご利用いただけません。',
  'kyc.mini.tips.desc.3': '＊外国籍のお客さまは、必ず在留カードまたは特別永住者証明書をご提出ください。',

  // 用户迁移升级 -- start
  web_upgrade_button: '取引システムをアップグレード',
  web_update_popup_title: '【OKJ取引システムのアップグレード】',
  web_update_popup_tips_one: 'OKJの取引システムが全面的に刷新されました。',
  web_update_popup_tips_two:
    '新しい取引システムにアップグレードするには、「今すぐ更新」ボタンをクリックしてください。',

  web_update_popup_tips_adv_title: '新取引システムの特長',
  web_update_popup_tips_adv_one: '1. 取引の基本機能の向上',
  web_update_popup_tips_adv_two:
    '2. ユーザーインターフェースの刷新による快適な取引体験',
  web_update_popup_tips_adv_three:
    '3. 大規模トラフィックへの耐性強化により、高いシステム安定性を確保',

  web_update_popup_tips_notice_title: '注意事項',
  web_update_popup_tips_notice_one:
    '• アップグレード時点までに約定されていない注文は、アップグレード後に自動キャンセルされます。',
  web_update_popup_tips_notice_two:
    '• {date} に新しい取引システムに自動アップグレードされます。',

  web_update_popup_button_later: '後で更新',
  web_update_popup_button_now: '今すぐ更新',

  web_update_popup_upgrading_title: 'アップグレード中',
  web_update_popup_upgrading_tips:
    '取引システムをアップグレード中です、しばらくお待ちください。',
  web_update_popup_upgrading_abnormal_tips:
    '{minute}分以上経ってもアップグレードされない場合は、お問い合わせください。',
  web_update_popup_upgrading_button: 'お問い合わせ',

  web_update_popup_upgrade_complete_title:
    '取引システムのアップグレードが完了しました。',
  web_update_popup_upgrade_complete_tips: '取引開始しましょう',
  web_update_popup_upgrade_complete_button_trade: '取引開始',
  // 用户迁移升级 -- end
};
